import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  createVideoTemplate,
  fetchVideoTemplateCategories
} from "../actions/index";
import VideoTemplatesForm from "./VideoTemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import * as Constants from '../constants';
import { Link } from "react-router-dom";

class VideoTemplatesNew extends Component {
  static propTypes = {
    createVideoTemplate: PropTypes.func.isRequired,
    fetchVideoTemplateCategories: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    categories: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchVideoTemplateCategories();
  }

  onSubmit(state) {
    this.props
      .createVideoTemplate(state)
      .then(response => {
        if (response.payload.status == "200") {
          toastr.success("Video created!");
          this.props.history.push(`/video_templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  render() {
    const { categories } = this.props;
    if (!categories.data) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    return (
      <div>
        <h1>Add New Video</h1>
        <VideoTemplatesForm
          match={this.props.match}
          location={this.props.location}
          handleSubmit={this.onSubmit.bind(this)}
          mode="new"
          categories={categories.data}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { categories: state.videoTemplateCategories.all };
}

export default connect(
  mapStateToProps,
  { createVideoTemplate, fetchVideoTemplateCategories }
)(VideoTemplatesNew);
